<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/portugal/douro-valley')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/casa-ferreirinha')">Casa Ferreirinha
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/howards-folly')">Howard’s Folly
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active two-line"
                               :to="localePath('/wine-guide/portugal/douro-valley/prats-and-symington')">Prats and
                        Symington (Chryseia)
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/quinta-do-crasto')">Quinta do Crasto
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/quinta-do-vale-meao')">Quinta Do Vale
                        Meao
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/quinta-do-vallado')">Quinta Do Vallado
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/quinta-do-vesuvio')">Quinta Do Vesuvio
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/portugal/douro-valley/roquette-cazes-quinta')">Roquette
                        &amp; Cazes — Quinta do Crasto
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/symington')">Symington
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/portugal/douro-valley')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Prats e Symington (Chryseia)</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Quando parli dei vini del Portogallo, saresti perdonato se i tuoi pensieri saltassero automaticamente ai vini di Porto. Dopotutto, l'omonimo prodotto della Valle del Douro è responsabile del cambiamento delle fortune del paese nel XVIII secolo e da allora ha ampiamente oscurato qualsiasi altra esportazione. Ci sono tuttavia una manciata di produttori desiderosi di riprendere il commercio del vino da tavola, e Chryseia è uno di loro.
                    </div>

                    <div class="howto-title2">Un rosso portoghese perfetto, potente</div>
                    <div class="howto-text">
                        Una joint venture tra l'esperto viticoltore James Symington (sì, quel James Symington della famosa famiglia del vino Porto) e Bruno Prats (di Château Cos d'Estournel), questi due vignaioli erculei sembrano aver colpito l'oro. Un'esperienza bordolese ibrida di Prats e la profonda conoscenza del terroir di Symington, la coppia si è unita nel 1999 e ha dato il via alla palla. Producendo sotto il nome di Prats &amp; Symington (o P+S), il vino risultante, Chryseia è entrata nella Top 100 di Wine Spectator solo alla sua seconda annata. Chiaramente un successo, la coppia ha poi acquisito ulteriori appezzamenti di terreno, tra cui gli storici vigneti e la cantina Quinta de Roriz nel 2009.
                    </div>

                    <div class="howto-title2">Nessuno ha colpito meraviglia</div>
                    <div class="howto-text">
                        Nel 2014 il vino si è ritrovato ancora una volta sul podio di Wine Spectator, questa volta al 3° posto per la sua offerta 2011. Il successo può essere in gran parte attribuito all'eccezionale lavoro di squadra di Symington e Prats, ma anche all'eccezionale piazzamento di Douro; la valle è annunciata come dotata di tutto, dall'essere selvaggiamente bella (è stata dichiarata Patrimonio dell'Umanità dall'UNESCO nel 2001) al clima fantastico, ai terreni fantastici e ai vitigni unici. La superba longevità dei vini della Valle del Douro non va dimenticata, non solo per Chryseia ma anche per il secondo vino di Prats e Symington, Post Scriptum. Questo secondo (attenzione, non minore) vino può raggiungere livelli eccezionali ma costa circa la metà di un Chryseia della stessa annata. P+S ha anche Prazo de Roriz.
                        <br><br>
                        Dopo il riconoscimento di Wine Spectators, l'annata 2011 è sempre più rara e sempre più costosa. L'attuale (Q2 2019) mostra stock di un solo caso sul mercato secondario in bond per € 1.800, o vicino a € 250 per bottiglia. Questo è comunque eccezionale; altre annate non millesimate vanno dai 50 ai 100 euro a bottiglia.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Prats und Symington (Chryseia)</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Wenn man über die Weine Portugals spricht, wäre es verzeihlich, wenn einem automatisch die Portweine in den Sinn kommen würden. Schließlich hat das gleichnamige Produkt aus dem Douro-Tal die Geschicke des Landes im 18. Jahrhundert verändert und seitdem alle anderen Exporte weitgehend in den Schatten gestellt. Es gibt jedoch eine Handvoll Produzenten, die daran interessiert sind, den Tafelweinhandel anzukurbeln, und Chryseia ist einer von ihnen.
                    </div>

                    <div class="howto-title2">Ein perfekter, kraftvoller portugiesischer Rotwein</div>
                    <div class="howto-text">
                        Als Joint Venture zwischen dem erfahrenen Weinbauer James Symington (ja, dieser James Symington aus der berühmten Portweinfamilie) und Bruno Prats (vom Château Cos d’Estournel) scheinen diese beiden Herkules-Winzer auf Gold gestoßen zu sein. Die beiden schlossen sich 1999 zusammen und brachten den Stein ins Rollen, eine Mischung aus Prats’ Bordelaise-Erlebnis und Symingtons tiefgreifenden Kenntnissen des Terroirs. Unter dem Namen Prats &amp; Symington (oder P+S), der daraus resultierende Wein Chryseia, schaffte es bereits im zweiten Jahrgang in die Top 100-Liste des Wine Spectator. Das Paar war offensichtlich ein Erfolg und erwarb 2009 weitere Grundstücke, darunter die historischen Weinberge und das Weingut Quinta de Roriz.
                    </div>

                    <div class="howto-title2">Niemand hat Wunder getroffen</div>
                    <div class="howto-text">
                        Im Jahr 2014 landete der Wein erneut auf dem Podium des Wine Spectator, dieses Mal auf dem 3. Platz für sein Angebot aus dem Jahr 2011. Der Erfolg ist größtenteils auf die außergewöhnliche Teamarbeit von Symington und Prats zurückzuführen, aber auch auf Douros außergewöhnliche Platzierung; Das Tal soll alles zu bieten haben, von wilder Schönheit (es wurde 2001 zum UNESCO-Weltkulturerbe erklärt) bis hin zu fantastischem Klima, großartigen Böden und einzigartigen Rebsorten. Auch die hervorragende Lagerfähigkeit der Weine aus dem Douro-Tal darf nicht vergessen werden, nicht nur bei Chryseia, sondern auch beim Zweitwein von Prats und Symington, Post Scriptum. Dieser Zweitwein (Achtung, nicht schlechter) kann hervorragende Ergebnisse erzielen, ist aber etwa halb so teuer wie ein Chryseia aus demselben Jahr. P+S hat auch Prazo de Roriz.
                        <br><br>
                        Seit der Auszeichnung durch die Wine Spectators wird der Jahrgang 2011 immer seltener und immer teurer. Aktuelle (Q2 2019) zeigen Lagerbestände von nur einer Kiste auf dem Sekundärmarkt in Anleihen für 1.800 €, also knapp 250 € pro Flasche. Dies ist jedoch außergewöhnlich; Andere Jahrgänge ohne Jahrgang kosten zwischen 50 und 100 € pro Flasche.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Prats et Symington (Chryseia)</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Lorsque vous parlez des vins du Portugal, vous seriez pardonné si vos pensées sautaient automatiquement sur les vins de Porto. Après tout, le produit éponyme de la vallée du Douro est responsable du changement de fortune du pays au XVIIIe siècle et a largement éclipsé toute autre exportation depuis. Il existe cependant une poignée de producteurs désireux de reprendre le commerce des vins de table, et Chryseia en fait partie.
                    </div>

                    <div class="howto-title2">Un rouge portugais parfait et puissant</div>
                    <div class="howto-text">
                        Une joint-venture entre le viticulteur expert James Symington (oui, ce James Symington de la célèbre famille du vin de Porto) et Bruno Prats (du Château Cos d'Estournel), ces deux vignerons herculéens semblent avoir trouvé de l'or. Une expérience hybride bordelaise de Prats et la connaissance approfondie du terroir de Symington, le duo s'est associé en 1999 et a lancé le bal. Produisant sous le nom de Prats &amp; Symington (ou P+S), le vin résultant, Chryseia a fait partie de la liste des 100 meilleurs vins du Wine Spectator dans son deuxième millésime seulement. Clairement un succès, le couple a ensuite acquis d'autres parcelles de terrain, y compris les vignobles et la cave historiques de Quinta de Roriz en 2009.
                    </div>

                    <div class="howto-title2">Personne ne s'est étonné</div>
                    <div class="howto-text">
                        En 2014, le vin se retrouve à nouveau sur le podium du Wine Spectator, cette fois à la 3 ème place pour son offre 2011. Le succès peut être largement attribué au travail d'équipe exceptionnel de Symington et Prats mais aussi au placement exceptionnel de Douro; la vallée est annoncée comme ayant tout, d'une beauté sauvage (elle a été déclarée site du patrimoine mondial de l'UNESCO en 2001) à un climat fantastique, de grands sols et des cépages uniques. La superbe capacité de garde des vins de la vallée du Douro ne doit pas non plus être oubliée, non seulement pour Chryseia mais aussi pour le second vin de Prats et Symington, Post Scriptum. Ce second vin (attention, pas moindre) peut atteindre des niveaux remarquables mais coûte environ la moitié du prix d'un Chryseia pour la même année. P + S ont également Prazo de Roriz.
                        <br><br>
                        Depuis la distinction des Wine Spectators, le millésime 2011 est de plus en plus rare et de plus en plus cher. Les stocks actuels (T2 2019) affichent une seule caisse sur le marché secondaire obligataire à 1 800 €, soit près de 250 € la bouteille. Ceci est cependant exceptionnel ; les autres années non millésimées oscillent entre 50 et 100 € la bouteille.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Prats and Symington (Chryseia)</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        When talking about the wines of Portugal, you would be forgiven if your thoughts automatically jumped to Port wines. After all, the eponymously named Douro Valley product is responsible for changing the country’s fortunes in the 18th century and has largely overshadowed any other export since. There are however a handful of producers who are keen to pick up the table wine trade, and Chryseia is one of them.
                    </div>

                    <div class="howto-title2">A perfect, powerful, Portuguese red</div>
                    <div class="howto-text">
                        A joint venture between expert viticulturist James Symington (yes, that James Symington of the famous Port wine family) and Bruno Prats (of Château Cos d’Estournel), these two herculean winemakers seem to have struck gold. A hybrid Prats’ Bordelaise experience and Symington’s deep knowledge of terroir, the pair teamed up in 1999 and set the ball rolling. Producing under the name Prats &amp; Symington (or P+S), the resulting wine, Chryseia made the Wine Spectator’s Top 100 list in just its second vintage. Clearly a success, the pair then went on to acquire further parcels of land, including the historic Quinta de Roriz vineyards and winery in 2009.
                    </div>

                    <div class="howto-title2">No one hit wonder</div>
                    <div class="howto-text">
                        In 2014 the wine once again found itself on the Wine Spectator’s podium, this time in 3 rd place for its 2011 offering. The success can largely be put down to the exceptional teamwork of Symington and Prats but also Douro’s exceptional placement; the valley is heralded as having everything from being wildly beautiful (it was declared a UNESCO World Heritage Site in 2001) to fantastic climate, great soils and unique grape varieties. The superb ageability of Douro Valley wines is not to be forgotten either, not only for Chryseia but for Prats and Symington’s’ second wine, Post Scriptum. This second (attention, not lesser) wine can reach outstanding levels but is around half the price of a Chryseia for the same year. P+S also have Prazo de Roriz.
                        <br><br>
                        Since the Wine Spectators accolade, the 2011 vintage is increasingly rare and increasingly expensive. Current (Q2 2019) show stocks at just one case on the secondary market in bond for €1,800, or close to €250 per bottle. This is exceptional however; other non-vintage years range between €50-100 a bottle.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PratsAndSymington",
    data() {
        return {
            select: {
                report: 'Prats and Symington (Chryseia)',
                src: '/wine-guide/portugal/douro-valley/prats-and-symington'
            },
            items: [
                {report: 'Casa Ferreirinha', src: '/wine-guide/portugal/douro-valley/casa-ferreirinha'},
                {report: 'Howard’s Folly', src: '/wine-guide/portugal/douro-valley/howards-folly'},
                {
                    report: 'Prats and Symington (Chryseia)',
                    src: '/wine-guide/portugal/douro-valley/prats-and-symington'
                },
                {report: 'Quinta do Crasto', src: '/wine-guide/portugal/douro-valley/quinta-do-crasto'},
                {report: 'Quinta Do Vale Meao', src: '/wine-guide/portugal/douro-valley/quinta-do-vale-meao'},
                {report: 'Quinta Do Vallado', src: '/wine-guide/portugal/douro-valley/quinta-do-vallado'},
                {report: 'Quinta Do Vesuvio', src: '/wine-guide/portugal/douro-valley/quinta-do-vesuvio'},
                {
                    report: 'Roquette & Cazes — Quinta do Crasto',
                    src: '/wine-guide/portugal/douro-valley/roquette-cazes-quinta'
                },
                {report: 'Symington', src: '/wine-guide/portugal/douro-valley/symington'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Prats and Symington | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the exceptional wines of Prats and Symington (Chryseia), a renowned wine producer in the Douro Valley region. Their commitment to quality and terroir-driven winemaking produces some of the most sought-after wines in the region. Experience the unique flavors and aromas of their premium wines today.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
